<template>
  <div class="bg">
    <img src="../assets/bg.png" alt="bg" class="bg" />
    <div class="box">
      <div class="msg">
        <img src="../assets/game-icon.png" alt="icon" class="icon" />
        <div>
          <p class="game-name">重装战姬</p>
          <p class="game-describe">新一代的【机甲x少女】主题手游！</p>
        </div>
      </div>
      <a
        href="http://storefile.ldmnq.com/apk/sHXtkt-1563328745628.apk?gameId=3622"
        target="_blank"
        class="download"
      ></a>
    </div>
  </div>
</template>

<script>
export default {
  name: "headtop"
};
</script>

<style lang="scss" scoped>
.bg {
  display: block;
  width: 100%;
  position: relative;
  .box {
    position: absolute;
    height: 85px;
    width: 100%;
    bottom: 0;
    left: 0;
    padding: 0 25px;
    box-sizing: border-box;
    background: rgba($color: #153978, $alpha: 0.8);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .msg {
      color: #fff;
      display: flex;
      align-items: center;
      .icon {
        width: 60px;
        height: 60px;
        margin-right: 15px;
      }
      .game-name {
        font-size: 18px;
        margin-bottom: 10px;
      }
      .game-describe {
        font-size: 16px;
      }
    }
    .download {
      width: 180px;
      height: 60px;
      background-image: url("../assets/dwn.png");
      background-size: 100% 100%;
    }
  }
}
</style>
